<template>
  <div id="app">
    <Head></Head>
    <div class="banner">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/banner-about-zh.png'"
        :alt="$t('langs.aboutus')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/banner-about-en.png'"
        :alt="$t('langs.aboutus')"
      />
    </div>
    <!-- <Tab /> -->
    <div class="lang-td">
      <span class="td_text_one">{{ $t("langs.companyIntroduction") }}</span>
    </div>
    <div class="row_line">
      <span class="td_line"></span>
    </div>
    <div class="about">
      <div class="about_text">
        <div class="about_memo">{{ $t("langs.abountmemo") }}</div>
        <div class="about_memo_two">{{ $t("langs.abountmemodetailed") }}</div>
        <div class="about_title">{{ $t("langs.currently") }}：</div>
        <div class="about-layer flex-col">
          <span class="about-word">{{ $t("langs.energystoragebattery") }}</span>
        </div>
        <div class="about-layer flex-col">
          <span class="about-word">{{ $t("langs.bmsbattery") }}</span>
        </div>
        <div class="about-layer flex-col">
          <span class="about-word">{{ $t("langs.cloudmanage") }}</span>
        </div>
        <div class="about-layer flex-col">
          <span class="about-word">{{ $t("langs.wificommunication") }}</span>
        </div>
      </div>
      <img :src="this.$path + '/assets/images/about.png'" :alt="$t('langs.aboutus')" />
    </div>
    <div class="background-section flex-col">
      <div class="about-main flex-col">
        <div class="about-box">
          <span class="word_text_one">{{ $t("langs.target") }}</span>
        </div>
        <div class="row_line">
          <span class="td_line"></span>
        </div>
      </div>
    </div>
    <div class="outer_one flex-col">
      <img
        class="outer_img_one"
        referrerpolicy="no-referrer"
        :src="this.$path + '/assets/images/bak_one.png'"
      />
    </div>
    <div class="outer_two flex-col">
      <img
        class="outer_img_two"
        referrerpolicy="no-referrer"
        :src="this.$path + '/assets/images/bak_two.png'"
      />
    </div>
    <div class="outer_three flex-col">
      <img
        class="outer_img_three"
        referrerpolicy="no-referrer"
        :src="this.$path + '/assets/images/bak_three.png'"
      />
    </div>
    <div class="section_bottom flex-row">
      <span class="word_one">{{ $t("langs.pioneering") }}</span>
      <span class="word_two">{{ $t("langs.cooperation") }}</span>
      <span class="word_three">{{ $t("langs.stableandmature") }}</span>
    </div>
    <div class="section_two">
      <span class="word17_about">{{ $t("langs.global") }}</span>
    </div>
    <div class="row_line">
      <span class="td_line"></span>
    </div>
    <div class="info_about_memo">{{ $t("langs.arayabout") }}</div>
    <div class="banner">
      <img :src="this.$path + '/assets/images/global.png'" :alt="$t('langs.global')" />
    </div>
    <Footer></Footer>
    <Hover></Hover>
  </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
// import Tab from "../components/about/tab.vue";
import Hover from "../components/hover";

export default {
  name: "about",
  components: { Head, Footer, Hover },
};
</script>
<style scoed>
@import "../assets/css/common.css";

.lang-td {
  text-align: center;
  width: 100%;
  margin-top: 30px;
  font-size: 20px;
}

.td_text_one {
  text-align: right;
  margin-right: -4px;
  font-size: 40px;
}

.row_line {
  width: 100%;
  text-align: center;
}

.td_line {
  height: 6px;
  background-color: #00d265;
  width: 150px;
  display: inline-block;
}

.about {
  width: auto;
  display: flex;
  /* margin-top: 20px; */
  padding: 15px 10%;
}
.about_text {
  flex-direction: row;
  align-items: center;
  flex: 1;
}

.about_title {
  color: #666;
  font-size: 30px;
  line-height: 42px;
  text-align: left;
  margin-top: 10px;
  font-weight: 700;
}

.about_memo {
  font-size: 16px;
  text-indent: 2em;
  color: #666666;
  letter-spacing: 1px;
  line-height: 22px;
  padding: 0px 7% 0px 0px;
}

.about_memo_two {
  padding-top: 10px !important;
  font-size: 16px;
  text-indent: 2em;
  color: #666666;
  letter-spacing: 1px;
  line-height: 22px;
  padding: 0px 7% 0px 0px;
}

.about img {
  width: 600px;
  height: 420px;
  border: 0px;
}

.about-layer {
  width: 8px;
  height: 8px;
  background-color: #00d265;
  border-radius: 50%;
  margin-top: 30px;
  justify-content: center;
}

.background-section {
  z-index: 20;
  height: 460px;
  background: url("../assets/images/background.png") 100% no-repeat;
  /* margin-top: 30px; */
  width: 100%;
  justify-content: flex-start;
  padding-top: 20px;
  align-items: center;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.about-word {
  height: 28px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  white-space: nowrap;
  line-height: 28px;
  text-align: left;
  margin-left: 20px;
}

.about-main {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}

.about-box {
  z-index: 100;
  width: auto;
  height: 48px;
  overflow-wrap: break-word;
  text-align: center;
  white-space: nowrap;
  align-self: center;
}

.word_text_one {
  font-size: 40px;
  color: rgba(51, 51, 51, 1);
  line-height: 48px;
  height: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word_text_two {
  font-size: 40px;
  color: rgba(1, 244, 127, 1);
  line-height: 56px;
  overflow: hidden;
  text-overflow: ellipsis;
  
}

.word_text {
  z-index: 100;
  width: 338px;
  height: 38px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 170, 170, 1);
  font-size: 28px;
  white-space: nowrap;
  line-height: 38px;
  text-align: left;
  margin-top: 8px;
}

.outer_one {
  z-index: 200;
  position: absolute;
  left: 16.5%;
  width: 280px;
  height: 424px;
  margin-top: -260px;
}

.outer_img_one {
  z-index: 200;
  position: absolute;
  left: 0;
  top: 0;
  width: 280px;
  height: 424px;
}

.outer_two {
  z-index: 200;
  position: absolute;
  left: 39%;
  width: 300px;
  height: 424px;
  margin-top: -260px;
}

.outer_img_two {
  z-index: 200;
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  height: 424px;
}

.outer_three {
  z-index: 200;
  position: absolute;
  left: 63%;
  width: 300px;
  height: 424px;
  margin-top: -260px;
}

.outer_img_three {
  z-index: 200;
  position: absolute;
  left: 0;
  top: 0;
  width: 280px;
  height: 424px;
}

.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.section_bottom {
  z-index: auto;
  height: 22px;
  margin-top: 190px;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 15.5%;
  margin-right: 15.5%;
}

.word_one {
  width: 280px;
  height: 22px;
  display: block;
  word-wrap: break-word;
  word-break: break-all;
  color: rgba(170, 170, 170, 1);
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-left: -10px;
}

.word_two {
  width: 280px;
  height: 22px;
  display: block;
  word-wrap: break-word;
  word-break: break-all;
  color: rgba(170, 170, 170, 1);
  font-size: 16px;
  text-align: center;
  margin-left: -10px;
}

.word_three {
  width: 280px;
  height: 22px;
  display: block;
  word-wrap: break-word;
  word-break: break-all;
  color: rgba(170, 170, 170, 1);
  font-size: 16px;
  text-align: center;
  margin-right: 20px;
}

.section_two {
  height: 56px;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  align-self: center;
  margin-top: 55px;
  font-size: 0;
  text-align: center;
}

.word17_about {
  font-size: 40px;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info_about_memo {
  height: auto;
  display: block;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  letter-spacing: 1px;
  margin-top: 40px;
  padding: 0px 13%;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/about_us.vue